import React from "react";
import Icon from "../Icon";

export default (props) => (
  <Icon viewBox="0 0 32 32" {...props}>
    <path
      d="M15 15c1-2 0-6 3-9s7-3 9-3c-2 2 0 6-3 9s-7 1-9 3zM3 5c6 6 12 10 12 22m0 0c0-6-2-10 0-12"
      fill="none"
    />
  </Icon>
);
